import React from "react";
import "./ServiceCards.css";
import {NavLink} from "react-router-dom"

const services = [
  {
    title: "DRY CLEAN",
    img: "/service/servicsr.webp",
    url:"/expert-services",
    icon: "👕",
  },
  {
    title: "Wash & Fold",
    img: "/service/washed-and-folded-clothes-in-blue-tones.webp",
       url:"/washfold",
    icon: "🧺",
  },
  {
    title: "Bed & Bath",
    img: "/service/how-to-clean-bed.jpg",
            url:"/drycleaning",
    icon: "🧼",
  },
  {
    title: "Press Only",
    img: "/service/2149117079.jpg",
            url:"/press-only"
,
    icon: "👟",
  },
  {
    title: "Bag Care",
    img: "/service/OIP.jpg",
       url:"/bagcare-section",
    icon: "👜",
  },
  {
    title: "Shoe Care",
    img: "/service/repair-copy.jpg",
            url:"/shoe-care"
,
    icon: "🧸",
  },
];

export default function ServiceCards() {
    const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return (
    <div className="services-wrapper">

      {/* 🔥 HEADER */}
      <div className="services-header">
        <h2 className="expertise-title">
        EXPLORE ALL FRESH CLEAN SERVICES
        </h2>

      <p className="expertise-subtitle">
  Discover a complete range of professional cleaning services designed for convenience and care.<br />
  We ensure quality, hygiene, and attention to detail in every order.
</p>
      </div>

      {/* 🔥 GRID */}
      <div className="services-container">
        {services.map((item, index) => (
          <div className="service-card-main" key={index}>
            <img src={item.img} alt={item.title} />

          <NavLink to={item.url} onClick={scrollToTop}>
            <div className="service-bottom">
              <div className="icon-crard-main">{item.icon}</div>
              <h3>{item.title}</h3>
            </div>
            </NavLink>  
          </div>
        ))}
      </div>

    </div>
  );
}